<template>
  <div>
      <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :loader='"dots"'
        :height='150'
        :width='150'
        :color= '"#F1557A"'
        :is-full-page="fullPage"></loading>
      <d-col v-for="(post, idx) in PostsListOne" v-if="idx < loadNum"  :key="idx" lg="3" md="6" sm="12" class="mb-4">
        <d-card class="card-small card-post card-post--1 video-card">
          <!-- <div
            :class="[`card-post__image wistia_embed wistia_async_${post.video_id}`]"
            style="width:100%;height:200px;"
          >&nbsp;</div> -->

   <div class="card-width">
    <!-- <cld-video :publicId="`${post.video_id}`" controls="false" showLogo="false" analytics="false">
                      <cld-transformation
                        gravity= "auto"                        
                        crop="fill"
                        width="auto"
                        height="250"
                       aspectRatio="1:1"
                      />
                    </cld-video> -->

                    <video
            :id="`demo-player-${idx}`"
            data-cld-show-logo="false"
          ></video>
          </div>
         
          <div class="card-box">
            <div class="card-post__author d-flex">
              <!-- <a
                href="#"
                class="card-post__author-avatar card-post__author-avatar--small"
                :style="{ backgroundImage: 'url(\'' + post.thumbnail + '\')' }"
              >Written by {{ post.thumbnail }}</a> -->
              <div class="sent-to-box">
                <p class="card-text d-inline-block mb-1 message-to">Sending To:</p>
                <h6 class="card-title">
                  <span href="#" class="text-fiord-blue">
                    {{
                    post.pending_users && post.pending_users.length >= 4 ?
                    post.pending_users[0].firstname + ', ' + post.pending_users[1].firstname + ', ' + post.pending_users[2].firstname + ' & ' + (post.pending_users.length - 3) + '-Others'
                    :
                    post.pending_users && post.pending_users.length == 3 ?
                    post.pending_users[0].firstname + ', ' + post.pending_users[1].firstname + ' & ' + post.pending_users[2].firstname
                    :
                    post.pending_users && post.pending_users.length == 2 ?
                    post.pending_users[0].firstname + ' & ' + post.pending_users[1].firstname
                    :
                    post.pending_users && post.pending_users.length == 1 ?
                    post.pending_users[0].firstname
                    :
                    'no user'
                    }}
                  </span>
                </h6>
              </div>
             
              <!-- <avatar  :username="`${post.admin.first_name}-${post.admin.last_name}`" backgroundColor="#F2557A" color="#ffffff"></avatar> -->
            </div>
            </div>
            <d-card-body class="sent-to-card">
               <span class="timestamp">{{post.admin.first_name}} {{post.admin.last_name}}</span>
                <span class="text-muted timestamp">{{moment(post.createdAt).format("MM/DD/YYYY hh:mm")}}</span>
            </d-card-body>
          
          <d-card-body class="stat-line">
            <d-button class="btn btn-blue btn-primary" @click=approveVideo(post._id)>
              Approve
            </d-button>
            <d-button class="btn btn-primary btn-red ml-1" @click=deleteVideo(post._id)>
              Reject
            </d-button>
           
          </d-card-body>
        </d-card>
      </d-col>
    <!-- </d-row> -->
   
    <d-row v-if="this.prevPage && this.nextPage" class="load-more-row">
      <d-col v-if="this.prevPage" lg="6" md="6" sm="6"  class = "mb-4" >
        <span class="load-more">
          <d-button class="btn btn-primary" @click="loadPreviousVideos()">Previous... </d-button>
        </span>
      </d-col>
      <d-col  lg="6" md="6" sm="6" class="mb-4">
        <span class="load-more">
          <d-button class="btn btn-primary" @click="loadMoreVideos()">Load More.. </d-button>
        </span>
      </d-col>
    </d-row>
      <d-row v-if="!this.nextPage && this.prevPage" class="load-more-row">
      <d-col lg="12" md="12" sm="12" class="mb-4">
        <span class="load-more">
          <d-button class="btn btn-primary" @click="loadPreviousVideos()">Previous... </d-button>
        </span>
      </d-col>
    </d-row>
    <d-row v-if="this.nextPage && !this.prevPage" class="load-more-row">
      <d-col lg="12" md="12" sm="12" class="mb-4">
        <span class="load-more">
          <d-button class="btn btn-primary" @click="loadMoreVideos()">Load More.. </d-button>
        </span>
      </d-col>
    </d-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import Avatar from 'vue-avatar'
import Vue from "vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

// import "quill/dist/quill.snow.css";
Vue.use(Loading);
// First Row of Posts
const PostsListOne = [];

export default {
  data() {
    return {
      PostsListOne,
      isLoading:true,
       prevPage:null,
      page:1,
      nextPage: null,
      player: null,
      loadNum: 12,
      fullPage:true,
      deleteAlert:false,
      VideoJustApprove:false
    };
  },
  mounted() {
     analytics.track('Viewed Approval Queue');
    window._wq = window._wq || [];
    _wq.push({
      id: "5bbw8l7kl5",
      options: {
        autoPlay: false,
        //  videoFoam: true,
        controlsVisibleOnLoad: false,
        playbar: false,
        // email: "lennythedog@wistia.com",
        // endVideoBehavior: "loop",
        fullscreenButton: false,
        // googleAnalytics: true,
        //  qualityControl: false,
        volumeControl: true,
        settingsControl: false,
        playButton: true,
        playerColor: "#f2557a",
        // seo: true,
        // stillUrl: "https://my-awesome-website.com/my-thumbnail-url.jpg",
        // volume: 0.5,
        wmode: "transparent",
        doNotTrack: true
      }
    });
  },
  computed: {
    ...mapState({
      videoType: state => state.dash.type,
      fetchPendingData: state => state.dash.fetchPendingData
    })
  },
  watch: {
    videoType(e) {
      if (e === "FETCH_PENDINGDVIDEO_SUCCESS") {
        this.isLoading = false
        this.page = this.fetchPendingData.page
        this.nextPage = this.fetchPendingData.nextPage
        this.prevPage= this.fetchPendingData.prevPage
        this.PostsListOne = this.fetchPendingData.docs;


        if(this.VideoJustApprove){
            this.$toasted.success("Approve", {
          icon: "hourglass_empty",
          fullWidth: false,
          keepOnHover: true,
          duration: 3000,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
        this.VideoJustApprove = false
        }
        const cld = cloudinary.Cloudinary.new({
          cloud_name: "givemagic",
          secure: true
        });

        if(this.PostsListOne && this.PostsListOne.length) {
          setTimeout(()=>{
            this.PostsListOne.map((item,index) => {
              this.player = cld.videoPlayer(`demo-player-${index}`, {
                showLogo: false,
                controls: true,
                colors: { accent: item.settings.primary_color },
                transformation: {
                  crop: "fill",
                  height: 268,
                  gravity: "auto",
                  aspectRatio: "1:1"
                },
                fluid: true
                //analytics: true
              });

              this.player.source(item.video_id, {
                colors: { accent: "green" },
                textTracks: {
                  captions: {
                    label: "English captions",
                    language: "en",
                    default: true,
                    url: item.video_subtitle
                  },
                  subtitles: [
                    {
                      label: "English subtitles",
                      language: "en",
                      url: item.video_subtitle
                    }
                  ]
                }
              });

            })
          },1000)
        }


        if(this.deleteAlert === true){
           this.$toasted.success("Reject", {
          icon: "hourglass_empty",
          fullWidth: false,
          keepOnHover: true,
          duration: 3000,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
        this.deleteAlert = false;
        }
      }
    else if (e === "DELETE_VIDEO_REQUEST") {
        this.isLoading = true;
        this.deleteAlert = true;
        analytics.track("Video rejected")
        // this.PostsListOne = this.fetchData;
      }
       else if (e === "DELETE_VIDEO_SUCCESS") {
         this.$store.dispatch("fetchPendingVideo");
      } else if (e === "DELETE_VIDEO_FAILED") {
        this.isLoading = false;
         this.$toasted.error(this.error, {
          icon: "error_outline",
          duration: 3000,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
      }
      else if(e === "APPROVAL_VIDEO_REQUEST"){
        this.isLoading = true
        this.VideoJustApprove = true
      }
        else if(e === "APPROVAL_VIDEO_SUCCESS"){
          const  data = this.page
         this.$store.dispatch("fetchPendingVideo",data);
      }
        else if(e === "APPROVAL_VIDEO_FAILED"){
        this.isLoading = false;
         this.$toasted.error(this.error, {
          icon: "error_outline",
          duration: 3000,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
      }else if(e == 'FETCH_PENDINGDVIDEO_REQUEST'){
        this.isLoading = true;

      }
    }
  },
  methods: {
    loadMoreVideos() {
      // this.loadNum = this.loadNum + 8;
      if(this.nextPage){
        this.PostsListOne=[]
        const  data = this.nextPage
        this.$store.dispatch("fetchPendingVideo" , data)
      }
    },
    loadPreviousVideos(){
      if(this.prevPage){
        this.PostsListOne=[]
        const  data = this.prevPage
        this.$store.dispatch("fetchPendingVideo" , data)
      }
    },
    moment: function(e) {
      return moment(e);
    },
     deleteVideo(deleteVideoId){
    this.$store.dispatch("rejectVideo" , deleteVideoId);
    },
    approveVideo(videoID){
      
      this.$store.dispatch("approveVideo" , videoID);
    }
  },
  created() {
    const  data = 1
    this.$store.dispatch("fetchPendingVideo",data);
  },
  components: {
    Avatar,
    Loading
  },
};
</script>
<style lang="scss">
.message-to {
  font-size: 10px;
  text-transform: uppercase;
}


.stat-line {
  font-size: 0.8rem !important;
}

.card-post__image {
  min-height: 10.3125rem;
}
.card-post__author {
  position: relative !important;
  left: 0px;
  bottom: 10px !important;
  margin-top: 0px;
  width:100%;
}

.reject {
  background: none;
  border: 1px solid #f2557a;
  color: #f2557a;
  margin-left:5px;
  :hover {
     }
}
.card-post__author-avatar--small {
  width: 3.1875rem;
  height: 3.1875rem;
}
.card-small {
  box-shadow: 0 2px 0 rgba(90, 97, 105, 0.11), 0 4px 8px rgba(90, 97, 105, 0.12),
    0 10px 10px rgba(90, 97, 105, 0.06), 0 7px 70px rgba(90, 97, 105, 0.1);
    background: #fff;
}
.video-card {
  position: relative;
  width: auto;
}
.card-width {
  display: flex;
  overflow: hidden;
  height: 308px !important;
}
.play-button {
  position: absolute;
  z-index: 10001;
  left: 28%;
  top: 10%;
  cursor: pointer;
  background: linear-gradient(#f4f5f8, #f1f3f6);
}

.stat-line {
  padding: 5px !important;
  margin: 0 auto;
  background: #f0f0f1;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  font-size: 1.2em;
  color: #212143;
}
.stat-line-stat {
  padding: 4px;
  text-align: center;
}
.card-box {
  display:flex;
  width:100%;
}
.sent-to-box {
  width:100%;
}
.cld-video {
  margin: 0 auto;
}

.card-title {
  line-height: 20px;
  font-size: 0.8rem !important;
}
</style>
